export default function verificaCodiceFiscale(cf){
    let validi, i, s, set1, set2, setPari, setDispari;
    if(!cf) {
        return false;
    }
    cf = cf.toUpperCase();
    if(cf.length !== 16){
        return false;
    }
    validi = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    for(i = 0; i < 16; i++){
        if(validi.indexOf(cf.charAt(i)) === -1){
            return false;
        }
    }
    set1 = "0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    set2 = "ABCDEFGHIJABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setPari = "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
    setDispari = "BAKPLCQDREVOSFTGUHMINJWZYX";
    s = 0;
    for(i = 1; i <= 13; i += 2){
        s += setPari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }
    for(i = 0; i <= 14; i += 2){
        s += setDispari.indexOf(set2.charAt(set1.indexOf(cf.charAt(i))));
    }
    if(s % 26 != cf.charCodeAt(15) - "A".charCodeAt(0)){
        return false;
    }
    return true;
}
